import { REMOVE_OBJ_FROM_ARRAY } from "../../../enums/Request/currentRequestControls.types";

export const removeObjfromArrayAction = (data) => {
    return {
        type: REMOVE_OBJ_FROM_ARRAY,
        payload: data,
    };
};
